import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import OPlaceholder from '../../../../../../Components/OElements/OPlaceholder';
import CardWithError from '../../../../../../Components/Common/CardWithError';
import CardWithoutData from '../../../../../../Components/Common/CardWithoutData';
import ODoughnutChart from '../../../../../../Components/General/Chart/ODoughnutChart';
import { fetchCriticalityList } from '../../../../../../slices/thunks';



const CriticalityObligations = ({ establishment_id, productive_cycle_id, title, subtitle, legendPosition, height, with_total = false, um = '' }) => {
    const dispatch = useDispatch();

    const selector = createSelector(
        state => state.ObligationEstablishments,
        result => ({
            data: result.fetchCriticalityList,
            isLoading: result.isObligationEstablishmentLoading,
            isSuccess: result.isObligationEstablishmentSuccess,
            isError: result.isObligationEstablishmentError,
        })
    );

    const { data, isLoading, isSuccess, isError } = useSelector(selector);

    useEffect(() => {
        dispatch(fetchCriticalityList({establishment_id, productive_cycle_id}));
    }, [establishment_id, productive_cycle_id]);

    const lengthChart = data?.length || 0;
    const seriesChart = data?.map(item => item.count) || [];  // Ajustado para tomar el valor de "count"
    const labelsChart = data?.map(item => item.name) || [];  // Sin cambios, ya que el campo "name" es correcto
    const colorsChart =  data?.map(item => item.color) || [];  // Sin cambios, ya que el campo "txcolor" es correcto   
    const labelsHeaderChart = ['Criticidad', um, '%']


    if (isLoading) {
        return <OPlaceholder />;
    }

    if (isError) {
        return <CardWithError title={title} />;
    }

    if (isSuccess && data) {
        return (
            <div className='h-100'>
                <ODoughnutChart
                    title={title}
                    subtitle={subtitle}
                    seriesChart={seriesChart}
                    labelsChart={labelsChart}
                    colorsChart={colorsChart}
                    legendPosition={legendPosition}
                    with_total={with_total}
                    height={height}
                    labelsHeaderChart={labelsHeaderChart}
                    um={um}
                />
            </div>
        );
    }

    return <CardWithoutData title={title} />;

};

export default CriticalityObligations;


